import { useQuery } from '@hooks/reactQuery';

import { getThresholds } from '@api/thresholdManagement';

import { isEmpty } from '@utils/common';

import { IThresholdDTO } from '@interfaces/alarms/dto/thresholdDTO';
import { IThreshold } from '@interfaces/alarms/threshold';
import { IVendor } from '@interfaces/cmModule/dto/cmModuleDTO';

import { TVendorsValues } from '@enums/common';

import { THRESHOLDS } from '@constants/queryKeys';

export interface IUseThresholds extends IVendor<TVendorsValues | null | undefined> {
	technologies: string[] | null;
}

export const useThresholds = (params: IUseThresholds): {
	thresholdsByTechnologies?: Record<string, any>;
	thresholds?: IThreshold[];
	isLoading: boolean;
} => {
	const { vendor, technologies } = params;

	const {
		data: thresholds,
		isFetching: isFetchingThresholds,
	} = useQuery<Array<IThreshold>>({
		queryKey: [
			THRESHOLDS,
			vendor,
			technologies,
		],
		queryFn: () => {
			return Promise.all(
				technologies
					? technologies.map(async (technology: string): Promise<any> => {
						const data = await getThresholds({ vendor, technology } as IThresholdDTO);

						return {
							technology: technology,
							items: data,
						};
					})
					: [],
			);
		},
		enabled: [!!vendor, !isEmpty(technologies)],
		refetchOnWindowFocus: false,
	});

	return {
		thresholdsByTechnologies: thresholds?.reduce((acc: any, item: any) => {
			acc[item.techology] = item.items;

			return acc;
		}, {}),
		thresholds: thresholds?.map((item: any) => item.items).flat(),
		isLoading: isFetchingThresholds,
	};
};
